module.exports = __webpack_public_path__ + "img/no-image.5b0c9085.jpg";